import Utilitiesjs from '../utilites';

export default class Modulesjs {
    constructor() {
        this.utilsjs = new Utilitiesjs;
    }

    expandContent(e) {
        e.preventDefault();
        var container$ = $(e.target).closest("div.expandable-tem");

        var content$ = container$.find(".content");
        var icon = container$.find(".expandable-icon")[0];
        var isOpen = icon.src.includes('/Content/images/icons/Up.svg');
        icon.src = isOpen ? '/Content/images/icons/Down.svg' : '/Content/images/icons/Up.svg';

        if (isOpen) content$.hide();
        else content$.show();


    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/Modules.js